
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/[cat]/[subcat]/[subsubcat]/[slug]",
      function () {
        return require("private-next-pages/archive/[cat]/[subcat]/[subsubcat]/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/[cat]/[subcat]/[subsubcat]/[slug]"])
      });
    }
  